export default "__VITE_ASSET__LUGyAN_S__"